import React, { Component } from "react";
import { Collapse } from "reactstrap";

class MenuGroup extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <div className="menu-group-item">
        <div className="menu-group-item-title" onClick={this.toggle}>
          {this.props.title}
        </div>
        {this.props.disabled ?
          <Collapse isOpen={false}>{this.props.children}</Collapse>
        :
          <Collapse isOpen={this.state.collapse}>{this.props.children}</Collapse>
        }
      </div>
    );
  }
}

export default MenuGroup;



// WEBPACK FOOTER //
// ./src/components/Sidebar/MenuGroup.jsx